// extracted by mini-css-extract-plugin
module.exports = {"main":"Dashboard_main__2NG35"};